import { render, staticRenderFns } from "./phones.vue?vue&type=template&id=92c2272c&scoped=true&"
import script from "./phones.vue?vue&type=script&lang=js&"
export * from "./phones.vue?vue&type=script&lang=js&"
import style0 from "./phones.vue?vue&type=style&index=0&id=92c2272c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c2272c",
  null
  
)

export default component.exports